import React from 'react';
import { AddressProvider } from './AddressContext';
import { PartnerProvider } from './PartnerContext';
import { MarketingProvider } from './MarketingContext';
import { ContentProvider } from './ContentContext';
import { ClubProvider } from './ClubContext';

export const DataProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <AddressProvider>
    <PartnerProvider>
      <MarketingProvider>
        <ContentProvider>
          <ClubProvider>
            {children}
          </ClubProvider>
        </ContentProvider>
      </MarketingProvider>
    </PartnerProvider>
  </AddressProvider>
);
